<template>
  <ejs-grid 
    ref='themeGrid'
    :dataSource="parentGrid"
    :childGrid="childGrid"
    :allowPaging="true"
    :allowSorting="true"
    :allowFiltering="true"
    :pageSettings="pageSettings"
    :toolbar="toolbar"
    :filterSettings="{ type: 'Menu' }"
    @toolbarClick="onToolbarClick"
  >
      <e-columns>
          <e-column field="tema" headerText="Tema" :customAttributes="{class: 'textComplete'}" />
          <e-column field="subtema" headerText="Sub-tema" :customAttributes="{class: 'textComplete'}" />
          <e-column field="asunto" headerText="Asunto" :customAttributes="{class: 'textComplete'}" />
      </e-columns>
  </ejs-grid>
</template>
<script>
import { AxiosAdaptor } from '@src/adapters/syncfusion-axios-adaptor';

import Compliance from './partials/Compliance.vue';

import { DataManager } from '@syncfusion/ej2-data';
import { 
  GridComponent, 
  ColumnDirective, 
  ColumnsDirective, 
  Page, 
  Sort, 
  Filter, 
  Toolbar,
  DetailRow
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "theme-search",
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'Compliance': Compliance,
  },
  data() {
    return {
      pageSettings: { pageSize: 10 },
      parentGrid: new DataManager({
        url: '/themes/search',
        adaptor: new AxiosAdaptor(),
      }),
      childGrid: {
        height: '300px',
        dataSource: new DataManager({
          url: '/themes/compliances',
          adaptor: new AxiosAdaptor(),
        }),
        queryString: 'id',
        columns: [
          { 
            field: 'titulo', 
            headerText: 'Cumplimiento',
            customAttributes: {class: 'textComplete'},
            template: () => {
              return { template: Compliance };
            }
          },
          { field: 'periodicidad', headerText: 'Periodicidad' },
          { field: 'relevancia', headerText: 'Relevancia' },
        ]
      },
      toolbar: [{
        text: 'Limpiar',
        tooltipText: '',
        prefixIcon: 'e-clear',
        id: 'customClearFilter',
        align: 'Right',
        cssClass: 'btn'
      }],
    }
  },
  provide: {
    grid: [Page,Sort,Filter,Toolbar,DetailRow]
  },
  methods: {
    onToolbarClick(args) {
      if (args.item.id === 'customClearFilter') {
        const grid = this.$refs.themeGrid.ej2Instances;
        grid.clearFiltering();
      }
    },
    refreshGrid() {
      const grid = this.$refs.themeGrid.ej2Instances;
      grid.refresh();
    }
  },
  created() {
    this.$eventHub.$on('onResetSwitchTenantsStructuring', () => {
      this.refreshGrid();
    });

    this.$eventHub.$on('refreshThemeSearchGrid', () => {
      this.refreshGrid();
    });
  },
};
</script>